/**
 * A wrapper around the MUI Link component that's using the Next.js Link.
 *
 * Component source based on: https://github.com/mui/material-ui/blob/HEAD/examples/nextjs-with-typescript/src/Link.tsx
 * Docs: https://mui.com/material-ui/guides/routing/#next-js
 */

import MuiLink, {LinkProps as MuiLinkProps} from '@mui/material/Link';
import {Link as TanstackLink, LinkProps as TanstackLinkProps} from '@tanstack/react-router';
import * as React from 'react';

export const Link = React.forwardRef<HTMLAnchorElement, TanstackLinkProps & MuiLinkProps>(function Link(props, ref) {
  return <MuiLink component={TanstackLink} ref={ref} {...props} />;
});
